"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreImportStoreProductsInnerVariantsInnerToJSON = exports.StoreImportStoreProductsInnerVariantsInnerFromJSONTyped = exports.StoreImportStoreProductsInnerVariantsInnerFromJSON = exports.instanceOfStoreImportStoreProductsInnerVariantsInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoreImportStoreProductsInnerVariantsInner interface.
 */
function instanceOfStoreImportStoreProductsInnerVariantsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreImportStoreProductsInnerVariantsInner = instanceOfStoreImportStoreProductsInnerVariantsInner;
function StoreImportStoreProductsInnerVariantsInnerFromJSON(json) {
    return StoreImportStoreProductsInnerVariantsInnerFromJSONTyped(json, false);
}
exports.StoreImportStoreProductsInnerVariantsInnerFromJSON = StoreImportStoreProductsInnerVariantsInnerFromJSON;
function StoreImportStoreProductsInnerVariantsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'colorId': !(0, runtime_1.exists)(json, 'color_id') ? undefined : json['color_id'],
        'enabled': !(0, runtime_1.exists)(json, 'enabled') ? undefined : json['enabled'],
        'position': !(0, runtime_1.exists)(json, 'position') ? undefined : json['position'],
        'discardedAt': !(0, runtime_1.exists)(json, 'discarded_at') ? undefined : json['discarded_at'],
        'primaryImageUrl': !(0, runtime_1.exists)(json, 'primary_image_url') ? undefined : json['primary_image_url'],
    };
}
exports.StoreImportStoreProductsInnerVariantsInnerFromJSONTyped = StoreImportStoreProductsInnerVariantsInnerFromJSONTyped;
function StoreImportStoreProductsInnerVariantsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'color_id': value.colorId,
        'enabled': value.enabled,
        'position': value.position,
        'discarded_at': value.discardedAt,
        'primary_image_url': value.primaryImageUrl,
    };
}
exports.StoreImportStoreProductsInnerVariantsInnerToJSON = StoreImportStoreProductsInnerVariantsInnerToJSON;
